import React, { useState } from 'react';
import { Row, Col, Button, Grid } from 'antd';
import { SwapOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { ProjectDto } from '@/core';
import { confirmation, Page } from '@/components';
import classes from './ProjectsConstructorLayout.module.scss';
import { MobileStepper } from './MobileStepper';

const { useBreakpoint } = Grid;

type ProjectsConstructorLayoutProps = {
  content: React.ReactNode;
  navigationControls: React.ReactNode;
  projectData: ProjectDto;
};

export const ProjectsConstructorLayout = ({
  content,
  navigationControls,
  projectData,
}: ProjectsConstructorLayoutProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const isTabletScreen = !screens.xl;

  const [isMobileStepper, setIsMobileStepper] = useState(false);

  const toggleMobileStepper = () => setIsMobileStepper((prev) => !prev);

  const closeConstructorPage = () => {
    confirmation.show({
      title: t('close.title'),
      body: t('close.body'),
      onConfirm: () => navigate('/projects'),
    });
  };

  return (
    <>
      <MobileStepper
        isActive={isMobileStepper}
        projectData={projectData}
        closeStepper={toggleMobileStepper}
      />
      <div className={classes.layout}>
        <Col className={classes.content}>{content}</Col>
        <Row className={classes.navigationControlsWrapper}>
          <Col {...Page.Body.defaultProps?.span}>
            <Col
              xl={{ span: 16, offset: 8 }}
              xxl={{ span: 15, offset: 9 }}
              className={classes.navigationControls}
            >
              {isTabletScreen ? (
                <Button
                  className={classes.toggleStepperBtn}
                  onClick={toggleMobileStepper}
                  icon={<SwapOutlined />}
                ></Button>
              ) : null}
              <Button size="large" className={classes.closeConstructorBtn} onClick={closeConstructorPage}>
                {t('closeBtn')}
              </Button>
              {navigationControls}
            </Col>
          </Col>
        </Row>
      </div>
    </>
  );
};
